import { useEffect, useState } from "react";
import client from "@/api/client";

export function useMyAssets() {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    client
      .get("/fleetcare/my-assets")
      .then((res) => {
        if (active) setAssets(res.data);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { assets, loading, needsPicker: assets.length > 1 };
}
